/**
 * Atomic Component: FilterChip
 * Displays a selectable filter chip
 */

import React from 'react';
import './FilterChip.css';

const FilterChip = ({ label, selected = false, color, onClick }) => {
  const chipStyle = {
    borderColor: color,
    color: selected ? 'white' : color,
    backgroundColor: selected ? color : 'transparent',
  };

  return (
    <button
      type="button"
      className={`filter-chip ${selected ? 'filter-chip--selected' : ''}`}
      style={chipStyle}
      onClick={onClick}
    >
      {label}
    </button>
  );
};

export default FilterChip;
